export default __webpack_public_path__ + "static/media/ic_date_range.db33d262.svg";